import { render, staticRenderFns } from "./category.modal.vue?vue&type=template&id=8cbb3ea0&"
import script from "./category.modal.vue?vue&type=script&lang=js&"
export * from "./category.modal.vue?vue&type=script&lang=js&"
import style0 from "./category.modal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports